import { DataTable, Spinner } from "@shopify/polaris";

import {
  LoadingContainer,
  NoCancellationData,
  ReasonSummaryTableWrapper,
} from "../../CancellationReasonsSettings/styles";
import { SummaryTabConfig } from "./types";

const COUNT_CELL_TEST_IDS: Record<string, string> = {
  Retained: "intercept-outcome-summary-retained-count",
  "Continued with cancellation": "intercept-outcome-summary-cancelled-count",
};

export const getInterceptTotalsTab = (isLoadingData: boolean, config: SummaryTabConfig) => ({
  id: config.id,
  value: getInterceptTotalsTabValue(isLoadingData, config),
  accessibilityLabel: config.label,
  content: <span data-testid="cancellation-intercept-outcome-summary-tab">{config.label}</span>,
});

function getInterceptTotalsTabValue(isLoadingData: boolean, config: SummaryTabConfig) {
  if (isLoadingData) {
    return (
      <LoadingContainer>
        <Spinner />
      </LoadingContainer>
    );
  }

  if (!config.rows?.length) {
    return (
      <NoCancellationData>
        <p>{config.emptyMessage}</p>
      </NoCancellationData>
    );
  }

  const rows = config.rows.map(([label, count]) => {
    const testId = typeof label === "string" ? COUNT_CELL_TEST_IDS[label] : undefined;
    return testId
      ? [
          label,
          <span key={testId} data-testid={testId}>
            {count}
          </span>,
        ]
      : [label, count];
  });

  return (
    <ReasonSummaryTableWrapper data-testid="cancellation-intercept-outcome-summary-panel">
      <DataTable
        columnContentTypes={["text", "numeric"]}
        headings={["Outcome", "Count"]}
        rows={rows}
        sortable={[false, false]}
        defaultSortDirection="descending"
        initialSortColumnIndex={1}
      />
    </ReasonSummaryTableWrapper>
  );
}
